module.exports = __webpack_public_path__ + "img/DAVID_CANNON_39-rs.afabd211.jpg";